import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

  
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\/+^])/g, "\\$1") + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export default function GdprModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = getCookie("gdpr_consent");

    const onLoaded = () => {
    
      if (!consent) {
       
        setTimeout(() => setShow(true), 600);
      }
    };

    if (document.readyState === "complete") {
      onLoaded();
    } else {
      window.addEventListener("load", onLoaded);
      return () => window.removeEventListener("load", onLoaded);
    }
  }, []);

  const handleAccept = () => {
    setCookie("gdpr_consent", "accepted", 365);
    setShow(false);
  };

  const handleDecline = () => {
    setCookie("gdpr_consent", "declined", 365);
    setShow(false);
  };

  if (!show) return null;

  const bannerStyle = {
    position: "fixed",
    left: "20px",
    right: "20px",
    bottom: "20px",
    zIndex: 2000,
    background: "#fff",
    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    borderRadius: "8px",
    padding: "18px",
    display: "flex",
    gap: "12px",
    alignItems: "center",
    maxWidth: "1100px",
    margin: "0 auto",
  };

  const textStyle = { flex: 1, fontSize: "14px", color: "#222" };

  return (
    <div style={bannerStyle} role="dialog" aria-label="cookie-consent">
      <div style={textStyle}>
        <div style={{ marginTop: "6px" }}>
          This website uses cookies to optimize your browsing experience,
          analyze site usage, and enhance our site's responsiveness to visitors.
          By continuing to use this website, you agree to our use of cookies.
          For more information, please refer to our{" "}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#f46363" }} 
          >
            <strong>Privacy Policy.</strong>
          </a>{" "}
        </div>
      </div>

      <div style={{ display: "flex", gap: "8px" }}>
        <Button variant="outline-secondary" onClick={handleDecline}>
          No
        </Button>
        <Button
          variant="primary"
          onClick={handleAccept}
          style={{
            backgroundColor: "#f46363",
            borderColor: "#f46363",
            color: "#fff",
          }}
        >
          Yes
        </Button>
      </div>
    </div>
  );
}
